import React from 'react';
import { Image } from '../../image/Image';
import styles from './AccordionPreviewImage.module.scss';

export const AccordionPreviewImage = ({ src }: Props) => (
    <Image src={src} className={styles.default} width={24} height={24} />
);

type Props = {
    src: string;
};